import { IChartTypesState, ISingleChartSetting } from './types'

export const defaultSingleChartSetting: ISingleChartSetting = {
  byTime: false,
  grow: false,
}
export const defaultChartTypes: IChartTypesState = {
  count: { ...defaultSingleChartSetting },
  date: { ...defaultSingleChartSetting },
  fullVolume: { ...defaultSingleChartSetting },
  pureProfit: { byTime: true, grow: false },
  fee: { ...defaultSingleChartSetting },
  missIndex: { ...defaultSingleChartSetting },
  profit: { ...defaultSingleChartSetting },
  volumeToAction: { ...defaultSingleChartSetting },
  feeToPureProfit: { ...defaultSingleChartSetting },
  volumeToPureProfit: { ...defaultSingleChartSetting },
  expectedProfit: { ...defaultSingleChartSetting},
  expectedProfitPercent: { ...defaultSingleChartSetting},
  avgTimeBetweenOrders: { ...defaultSingleChartSetting},
}
